const componentFactory = (primaryField, field, value, onChange) => {
  return null;
};

export default componentFactory;
